export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10872.c8cd8743.jpg";